module.exports = __webpack_public_path__ + "static/img/luck-bag.a3c0d4f5.png";